<template src="./KiovietTabComponent.html"></template>
<script>
import IconHome from "@/components/icons/IconHome.vue";
import BreadcrumbComponent from "@/components/breadcrumb/BreadcrumbComponent.vue";
import InputTextNormal from "@/components/inputs/input-text/normal/InputTextNormal.vue";
import SelectNormal from "@/components/inputs/select/normal/SelectNormal.vue";
import ButtonSearchComponent from "@/components/buttons/button-search/ButtonSearchComponent.vue";
import {ref} from "vue";
import CommonService from "@/services/common.service.ts";
import {AppConstant} from "@/supports/app.constant.js";
import TabProductComponent
  from "@/pages/settings/sync-kioviets/show-tabs/tab-action-kiot/tab-product/TabProductComponent.vue";
import TabInvoiceComponent
  from "@/pages/settings/sync-kioviets/show-tabs/tab-action-kiot/tab-invoice/TabInvoiceComponent.vue";
import TabPartnerComponent
  from "@/pages/settings/sync-kioviets/show-tabs/tab-action-kiot/tab-partner/TabPartnerComponent.vue";
import TabDeliveriesComponent
  from "@/pages/settings/sync-kioviets/show-tabs/tab-action-kiot/tab-delivery/TabDeliveriesComponent.vue";

export default {
  name: 'ConnectKiovietComponent',
  computed: {
    AppConstant() {
      return AppConstant
    }
  },
  components: {
    ButtonSearchComponent,
    SelectNormal,
    InputTextNormal,
    BreadcrumbComponent,
    TabProductComponent,
    TabInvoiceComponent,
    TabPartnerComponent,
    TabDeliveriesComponent,
    IconHome
  },
  setup() {
    const tabCurrent = ref(AppConstant.TAB_PRODUCT_KIOTVIET)

    function changeTab(type = 'product') {
      tabCurrent.value = AppConstant.TAB_PRODUCT_KIOTVIET
      if(type === 'invoice') {
        tabCurrent.value = AppConstant.TAB_INVOICE_KIOTVIET
      }
      if(type === 'partner') {
        tabCurrent.value = AppConstant.TAB_PARTNER_KIOTVIET
      }
      if(type === 'delivery') {
        tabCurrent.value = AppConstant.TAB_DELIVERY_KIOTVIET
      }
    }

    return {
      tabCurrent,
      changeTab,
      CommonService,
      AppConstant
    }
  }
}
</script>
<style lang="scss">
.dashboard-page {
  margin-top: 80px;
  margin-left: 80px;
  height: 100%;
  .title-page {
    padding: 15px 30px;
    background-color: #fff;
  }
  .container-fluid {
    padding-top: 30px;
    .card {
      margin-bottom: 30px;
      letter-spacing: .5px;
      box-shadow: 0 9px 20px rgba(46,35,94,.07);
      .card-body {
        padding: 30px;
        border-radius: 15px;
        background-color: #ffffff;
      }
    }
  }
}
</style>